const TinyMceConfig = {
	autofocus: true, // Prevent TinyMCE from rendering at the wrong height
	// TinyMCE resolves the path to content_css in a relative way, so for each
	// component using TinyMCE,
	// :pathContext: should be replaced with the appropriate number of '../'s.
	// Do this in each individual component by copying this config object, edit
	// the path, then pass the new object into TinyMCE
	// See the textbox component in the editor for an example.
	content_css: ':pathContext:webapps/features/form-builder/css/tinymce.css,/apps/js/tinymce5/custom_content.css',
	cache_suffix: `?_=${new Date().getTime()}`,
	menubar: false,
	// Themes, plugins, and skins must have their paths manually specified.
	// Otherwise, IE11 will resolve the paths incorrectly in production build.
	// Attempting to use TinyMCE's 'document_base_url', 'relative_urls', and
	// 'remove_script_host' properties do not have any effect.
	theme_url: '/apps/webapps/common/tinymce/themes/silver/theme.min.js',
	external_plugins: {
		'advlist': '/apps/js/tinymce5/5.4.2/plugins/advlist/plugin.min.js',
		'autoresize': '/apps/js/tinymce5/5.4.2/plugins/autoresize/plugin.min.js',
		'autolink': '/apps/js/tinymce5/5.4.2/plugins/autolink/plugin.min.js',
		'code': '/apps/js/tinymce5/5.4.2/plugins/code/plugin.min.js',
		'edlio_image': '/apps/js/tinymce5/5.4.2/plugins/edlio_image/plugin.min.js',
		'link': '/apps/js/tinymce5/5.4.2/plugins/link/plugin.min.js',
		'lists': '/apps/js/tinymce5/5.4.2/plugins/lists/plugin.min.js',
		'print': '/apps/js/tinymce5/5.4.2/plugins/print/plugin.min.js',
		'preview': '/apps/js/tinymce5/5.4.2/plugins/preview/plugin.min.js',
		'table': '/apps/js/tinymce5/5.4.2/plugins/table/plugin.min.js',
		'edlio_stickytoolbar': '/apps/js/tinymce5/5.4.2/plugins/edlio_stickytoolbar/plugin.min.js',
	},
	skin_url: '/apps/webapps/common/tinymce/skins/ui/oxide',
	statusbar: false,
	toolbar: 'undo redo | bold italic | format alignleft aligncenter alignright | bullist numlist | outdent indent | forecolor | link | code | removeformat | fontsizeselect | styleselect | table | image floatLeft centerContent floatRight',
	toolbar_drawer: 'floating',
	style_formats: [{
			title: 'Underline',
			icon: 'underline',
			format: 'underline'
		},
		{
			title: 'Strikethrough',
			icon: 'strike-through',
			format: 'strikethrough'
		},
		{
			title: 'Superscript',
			icon: 'superscript',
			format: 'superscript'
		},
		{
			title: 'Subscript',
			icon: 'subscript',
			format: 'subscript'
		},
		{
			title: 'Code',
			icon: 'sourcecode',
			format: 'code'
		},
		{
			title: 'Headers',
			items: [{
					title: 'Header 2',
					format: 'h2'
				},
				{
					title: 'Header 3',
					format: 'h3'
				}
			]
		},
		{
			title: 'Blocks',
			items: [{
					title: 'Paragraph',
					format: 'p'
				},
				{
					title: 'Blockquote',
					format: 'blockquote'
				},
				{
					title: 'Div',
					format: 'div'
				}
			]
		}
	],
	color_map: [

		"686868", "Dove Gray",
		"cf000f", "Red",
		"b500b5", "Deep Magenta",
		"445bff", "Dodger Blue",
		"008500", "Japanese Laurel",

		"555555", "Rich Gray",
		"aa0000", "Deep Red",
		"b200fd", "Electric Violet",
		"3629ff", "Blue",
		"006800", "Camarone",

		"444444", "Tundora",
		"800000", "Maroon",
		"7023b7", "Purple Heart",
		"0000e0", "Bluish",
		"005500", "Camarone",

		"282828", "Mine Shaft",
		"804028", "Nutmeg",
		"561b8d", "Daisy Bush",
		"00008b", "Navy Blue",
		"003636", "Deep Teal",

		"000000", "Black",
		"3c2109", "Chocolate",
	],
	formats: {
		floatLeftWithPadding: {
			selector: 'img',
			styles: {
				float: 'left',
				padding: '10px',
				marginLeft: 'inherit',
				marginRight: 'inherit'
			}
		},
		floatRightWithPadding: {
			selector: 'img',
			styles: {
				float: 'right',
				padding: '10px',
				marginLeft: 'inherit',
				marginRight: 'inherit'
			}
		},
		centerSelection: {
			selector: 'img',
			styles: {
				padding: '10px',
				marginLeft: 'auto',
				marginRight: 'auto',
				display: 'block',
				float: 'none'
			}
		}
	},
	setup: function (ed) {

		ed.ui.registry.addIcon('float-left', '<svg width="18" height="18"><use xlink:href="/apps/webapps/next/global/blazer/icons/icons.svg#float-left"></use></svg>');
		ed.ui.registry.addIcon('center-content', '<svg width="18" height="18"><use xlink:href="/apps/webapps/next/global/blazer/icons/icons.svg#edlio_centered"></use></svg>');
		ed.ui.registry.addIcon('float-right', '<svg width="18" height="18"><use xlink:href="/apps/webapps/next/global/blazer/icons/icons.svg#float-right"></use></svg>');

		ed.ui.registry.addToggleButton('floatLeft', {
			icon: "float-left",
			tooltip: "Align image left",
			onAction: function (_) {
				if (ed.selection.getNode().nodeName == "IMG") {
					ed.execCommand('mceToggleFormat', false, 'floatLeftWithPadding');
					addClass(_.isActive(), ed.selection.getNode());
					addClass(_.isActive(), ed.selection.getNode().parentNode);
					ed.execCommand("mceRepaint");
				}
			},
			onSetup: function (api) {
				ed.formatter.formatChanged('floatLeftWithPadding', function (state) {
					api.setActive(state);
				});
			}
		});

		ed.ui.registry.addToggleButton('centerContent', {
			icon: "center-content",
			tooltip: "Center align content",
			onAction: function (_) {
				if (ed.selection.getNode().nodeName == "IMG") {
					ed.execCommand('mceToggleFormat', false, 'centerSelection');
				}
			},
			onSetup: function (api) {
				ed.formatter.formatChanged('centerSelection', function (state) {
					api.setActive(state);
				});
			}
		});

		ed.ui.registry.addToggleButton('floatRight', {
			icon: "float-right",
			tooltip: "Align image right",
			onAction: async function (_) {
				if (ed.selection.getNode().nodeName == "IMG") {
					ed.execCommand('mceToggleFormat', false, 'floatRightWithPadding');
					addClass(_.isActive(), ed.selection.getNode());
					addClass(_.isActive(), ed.selection.getNode().parentNode);
					ed.execCommand("mceRepaint");
				}
			},
			onSetup: function (api) {
				ed.formatter.formatChanged('floatRightWithPadding', function (state) {
					api.setActive(state);
				});
			}
		});

		ed.ui.registry.addContextToolbar('image-menu', {
			predicate: function (node) {
				return node.nodeName.toLowerCase() === 'img'
			},
			position: 'node',
			scope: 'node',
			items: 'link image floatLeft centerContent floatRight'
		});

	},
	file_browser_callback_types: 'image',
	file_picker_callback: function (callback, value, meta) {
		if (meta.filetype === 'image') {
			this.fileInputEl = document.createElement('input');

			this.fileInputEl.setAttribute('type', 'file');
			this.fileInputEl.setAttribute('id', 'fileTMCE');
			this.fileInputEl.setAttribute('accept', 'image/*');
			this.fileInputEl.style.display = 'none';

			document.body.appendChild(this.fileInputEl);

			this.fileInputEl.addEventListener('change', (evt) => {
				let formData = new FormData();
				let request = new XMLHttpRequest();
				let {
					files
				} = evt.target;

				let basePath = window.edlio.public_site_uri;

				if (basePath.endsWith('/')) {
					basePath = basePath.slice(0, -1);
				}

				let uploadPath = '/apps/api/images/upload';

				// add uploading status
				document.body.setAttribute("data-loading", "uploading...");

				formData.append('file', files[0]);

				request.onreadystatechange = () => {
					if (request.readyState === XMLHttpRequest.DONE) {
						if (request.status === 200) {
							let responses = JSON.parse(request.responseText);

							if (responses.length === 1) {
								callback(`${basePath}${responses[0].url}`);
							}

							//remove uploading status
							document.body.removeAttribute("data-loading");
						} else {
							document.body.setAttribute("data-loading", "failed, please try again later");
							setTimeout(function () {
								document.body.removeAttribute("data-loading");
							}, 3000);
						}
					}

					if (this.fileInputEl && this.fileInputEl.parentNode) {
						this.fileInputEl.parentNode.removeChild(this.fileInputEl);
					}
				};

				request.open('POST', uploadPath);
				request.send(formData);
			}, false);

			this.fileInputEl.click();
		}
	},
	relative_urls: false
};

const addClass = (active, node) => {
	if (active) {
		node.classList.add('floating-image');
	}
}

export default TinyMceConfig;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/tinymce-config.js